import React from "react";

export default function T20BettingPage() {
  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white md:mt-14">
      <main className="max-w-5xl mx-auto px-4 py-8">
        <h1 className="text-3xl md:text-4xl font-extrabold">T20 Betting Guide on IQ Cage</h1>
        <p className="mt-3 text-slate-300 leading-7">
          IQ Cage offers live T20 betting markets with a fast, mobile-friendly bet slip and real-time odds updates.
          You can bet on match winner, total runs, and next-ball outcomes while tracking score movement and momentum.
        </p>

        <section className="mt-6 rounded-xl bg-[#141925] border border-[#242c3d] p-5">
          <h2 className="text-xl font-bold">Popular T20 Markets</h2>
          <ul className="mt-3 list-disc pl-6 text-slate-300 space-y-1">
            <li>Match Winner</li>
            <li>Total Runs Over / Under</li>
            <li>Next Ball Runs (0,1,2,4,6,Wicket)</li>
            <li>Top Team Performance Trends</li>
          </ul>
        </section>

        <section className="mt-6 rounded-xl bg-[#141925] border border-[#242c3d] p-5">
          <h2 className="text-xl font-bold">Why players search IQ Cage for T20 betting</h2>
          <p className="mt-2 text-slate-300 leading-7">
            IQ Cage combines cricket prediction markets with clean UX, quick stake controls, transparent odds display,
            and integrated USDT wallet flow.
          </p>
          <div className="mt-4 flex flex-wrap gap-2 text-xs">
            {[
              "t20 betting app",
              "cricket betting with usdt",
              "next ball betting",
              "iq cage t20",
              "live t20 odds",
            ].map((k) => (
              <span key={k} className="px-2 py-1 rounded bg-[#20273a] border border-[#303a52] text-slate-300">
                {k}
              </span>
            ))}
          </div>
        </section>

        <div className="mt-8">
          <a href="/" className="text-emerald-300 hover:text-emerald-200 font-semibold">
            ← Back to IQ Cage Home
          </a>
        </div>
      </main>
    </div>
  );
}
